module.exports = __webpack_public_path__ + "img/fruit-clementines-350x184.93029aa6.jpg";